// @flow strict
import { Tabs } from 'antd';
import React from "react";
import Invoices from './Invoices';
import SubscriptionData from './SubscriptionData';

function Billing() {

  return (
    <div className="container px-3 px-md-5 py-3 billing pb-5">
      <Tabs
        items={[
          {
            label: 'Subscription',
            key: 'subscription',
            children: <SubscriptionData />
          },
          {
            label: 'Payment Invoices',
            key: 'invoice',
            children: <Invoices />
          },
        ]}
      />
    </div >
  );
};

export default Billing;